// src/pages/SellerIntelligence/Pricing/Pricing.js
//
// Pricing Strategy Analyzer.
//
// All five sub-features are built. SF1 is the engine the rest of this PRD set
// hangs off: Promotion Performance Tracker SF2 is defined in its own PRD as
// "covered by Pricing Strategy Analyzer SF1", and the Promotional Calendar is in
// turn covered by that.
//
// SF3 and SF5 are built but waiting on an offer capture that does not run yet,
// and they say so specifically rather than rendering as empty tables.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

import styles from '../SellerIntelligence.module.css';
import PriceImpact from './components/PriceImpact';
import Elasticity from './components/Elasticity';
import Recommendations from './components/Recommendations';
import MarketPosition from './components/MarketPosition';

const Pricing = () => {
  const navigate = useNavigate();
  return (
    <div className={styles.featureContainer}>
      <div className={styles.header}>
        <button className={styles.backButton}
          onClick={() => navigate('/dashboard/seller-intelligence/pricing')}>
          <FiArrowLeft /> Back
        </button>
        <div className={styles.titleSection}>
          <div className={styles.iconTitle}><h1>Pricing Strategy Analyzer</h1></div>
          <p>What every price change and deal actually did to your margin.</p>
        </div>
      </div>

      <div className={styles.content}>
        <PriceImpact />
        <Elasticity />
        <Recommendations />
        <MarketPosition />
      </div>
    </div>
  );
};

export default Pricing;
